module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner announcement"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("新建应用场景发布")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "inline-message": "true",
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入场景标题"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("应用场景")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "scenes"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入场景"
    },
    model: {
      value: (_vm.params.scenes),
      callback: function($$v) {
        _vm.$set(_vm.params, "scenes", $$v)
      },
      expression: "params.scenes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("所在地点")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "address"
    }
  }, [_c('ads-select', {
    attrs: {
      "adsList": _vm.adsStore,
      "selectType": "1"
    },
    on: {
      "selected": _vm.mapChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("推荐单位")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入推荐单位"
    },
    model: {
      value: (_vm.params.recommendOrganization),
      callback: function($$v) {
        _vm.$set(_vm.params, "recommendOrganization", $$v)
      },
      expression: "params.recommendOrganization"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tagNames"
    }
  }, [_c('tag-select', {
    attrs: {
      "selectTags": _vm.params.tagNames,
      "paramsKey": "tagNames"
    },
    on: {
      "selectChange": _vm.tagChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("封面图片")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('img-upload', {
    attrs: {
      "image": _vm.params.image,
      "tips": "（115*70推荐）"
    },
    on: {
      "imgChange": _vm.imgChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block scene-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("场景需求")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('textEditor', {
    ref: "textEditor",
    attrs: {
      "inContent": _vm.params.content
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block radio-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("可见范围")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.radioType),
      callback: function($$v) {
        _vm.radioType = $$v
      },
      expression: "radioType"
    }
  }, [_c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 1
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 2
    }
  }, [_vm._v("指定类型")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 3
    }
  }, [_vm._v("指定企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "size": "medium",
      "label": 4
    }
  }, [_vm._v("指定用户")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block check-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [(_vm.radioType == 2) ? _c('div', [_c('el-checkbox-group', {
    model: {
      value: (_vm.idArr1),
      callback: function($$v) {
        _vm.idArr1 = $$v
      },
      expression: "idArr1"
    }
  }, _vm._l((_vm.selectList1), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.radioType == 3) ? _c('div', {
    staticClass: "check-seek"
  }, [_c('div', {
    staticClass: "seek-head"
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.entSeek,
      "loading": _vm.loading1,
      "placeholder": "搜索企业名称"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.entId),
      callback: function($$v) {
        _vm.entId = $$v
      },
      expression: "entId"
    }
  }, _vm._l((_vm.selectList2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.entSelect
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seek-body"
  }, _vm._l((_vm.idArr2), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "danger",
        "closable": ""
      },
      on: {
        "close": function($event) {
          _vm.entRemove(index)
        }
      }
    }, [_vm._v("\n                                   " + _vm._s(item.name) + "\n                                 ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.radioType == 4) ? _c('div', {
    staticClass: "check-seek"
  }, [_c('div', {
    staticClass: "seek-head"
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.userSeek,
      "loading": _vm.loading2,
      "placeholder": "搜索用户"
    },
    model: {
      value: (_vm.userId),
      callback: function($$v) {
        _vm.userId = $$v
      },
      expression: "userId"
    }
  }, _vm._l((_vm.selectList3), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v("（" + _vm._s(item.enterpriseName) + "）")])])
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.userSelect
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seek-body"
  }, _vm._l((_vm.idArr3), function(item, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "type": "danger",
        "closable": ""
      },
      on: {
        "close": function($event) {
          _vm.userRemove(index)
        }
      }
    }, [_vm._v("\n                                   " + _vm._s(item.name) + "（" + _vm._s(item.enterpriseName) + "）\n                                 ")])
  }))]) : _vm._e()])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(1)
      }
    }
  }, [_vm._v("立即发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(2)
      }
    }
  }, [_vm._v("存为草稿")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-7d11a985"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/announcement/apcEdit.vue
// module id = 1532
// module chunks = 1